// The Load Shifting / Peak Shaving master switches (NEU-1226, design NEU-697 / NEU-1225).
// They are switched only in Settings, behind a type-CONFIRM dialog; every header shows a
// read-only status.

export const LSPS = {
  load_shifting: { name: "Load Shifting", field: "switch_load_shifting", activeKey: "load_shifting" },
  peak_shaving: { name: "Peak Shaving", field: "switch_peak_shaving", activeKey: "peak_shaving" },
};

/** Off, Standby (on, no schedule in effect now) or Active (on and a schedule in effect). */
export function lspsStatus(on, active) {
  if (!on) return { tone: "off", label: "Off", title: "off" };
  return active
    ? { tone: "active", label: "Active", title: "on and active" }
    : { tone: "standby", label: "Standby", title: "on, no schedule currently active" };
}

export const CONFIRM_WORD = "CONFIRM";

/** Exact and case-sensitive: "confirm" or " CONFIRM" don't count. */
export function isConfirmMatch(text) {
  return text === CONFIRM_WORD;
}

/** The dialog's words for switching `name` on or off. */
export function confirmCopy(name, turnOn) {
  return {
    title: `Turn ${turnOn ? "on" : "off"} ${name}?`,
    impact: `${name} schedules will ${turnOn ? "be applied." : "stop being applied."}`,
    action: turnOn ? "Turn on" : "Turn off",
    done: `${name} turned ${turnOn ? "on" : "off"}.`,
  };
}
